import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Appointment from './pages/Appointment';
import PricingGrid from './components/PricingGrid';
import Quote from './pages/Quote';
import Tracking from './pages/Tracking';
import Schedule from './pages/Schedule';
import Contact from './pages/Contact';
import theme from './theme/theme';
import './styles/responsive.css';

// Theme configuration
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#FFB700', // Orange-jaune vif
//       light: '#FFD000', // Jaune soleil
//       dark: '#FFA000', // Orange-jaune plus profond
//     },
//     secondary: {
//       main: '#dc004e',
//       light: '#ff4081',
//       dark: '#c51162',
//     },
//   },
//   typography: {
//     fontFamily: [
//       'Roboto',
//       'Arial',
//       'sans-serif',
//     ].join(','),
//     h1: {
//       fontWeight: 700,
//     },
//     h2: {
//       fontWeight: 600,
//     },
//     h3: {
//       fontWeight: 600,
//     },
//     h4: {
//       fontWeight: 600,
//     },
//     h5: {
//       fontWeight: 500,
//     },
//     h6: {
//       fontWeight: 500,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           fontWeight: 600,
//           padding: '8px 24px',
//         },
//         contained: {
//           boxShadow: 'none',
//           '&:hover': {
//             boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
//           },
//         },
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
//           '&:hover': {
//             boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
//           },
//         },
//       },
//     },
//     MuiDivider: {
//       styleOverrides: {
//         root: {
//           margin: '24px 0',
//         },
//       },
//     },
//     MuiStepLabel: {
//       styleOverrides: {
//         label: {
//           fontWeight: 500,
//         },
//       },
//     },
//   },
// });

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
        <CssBaseline />
        <Router>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
            }}
          >
            <Navbar />
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                width: '100%',
                overflow: 'hidden',
              }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/appointment" element={<Appointment />} />
                <Route path="/pricing" element={<PricingGrid />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/tracking" element={<Tracking />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
